import { commonId } from './ns/common';
import { enumId } from './ns/enum';
import { cashierId } from './ns/cashier';
import { healthId } from './ns/health';
import { tableId } from './ns/table';
import { guestCallId } from './ns/guest-call';
import { kdsId, queueId } from './ns/kds';
import { waiterId } from './ns/waiter';
import { sessionId } from './ns/session';

/** Mode `id` = SUMBER KEBENARAN. Nilai di sini adalah teks yang benar-benar tampil. */
export const id = {
  common: commonId,
  enum: enumId,
  cashier: cashierId,
  health: healthId,
  table: tableId,
  guestCall: guestCallId,
  kds: kdsId,
  waiter: waiterId,
  queue: queueId,
  session: sessionId,
};
